<template>
  <div>
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'Illustrate',
  data () {
    return {
      message: 'TODO: /works/illustrate'
    }
  }
}
</script>

<style module>
  
</style>
